/**
 * Classificação de MOVIMENTO do ativo. Vive em `constants/` e não dentro do
 * componente porque é regra de negócio: o que conta como entrada e o que conta
 * como saída de recurso decide a cor/rótulo do marcador de movimentação no
 * gráfico do ativo (`utils/asset-markers`), e a mesma regra vale para qualquer
 * superfície que classifique movimento.
 *
 * As duas listas são POSITIVAS e NÃO são complementares: cupom, vencimento e
 * amortização não são nem aplicação nem resgate. Filtrar uma por negação da
 * outra rotula esses três errado.
 */

export const APLICACAO_PATTERN = /aplica|compra|inicial/i

export const RESGATE_PATTERN = /resgate|venda/i

/** Fração (0,08145) para percentual (8,145). */
export const FRACTION_TO_PERCENT = 100
